'use client';

import { useClientContext } from '@dealerportal/react-helpers';
import classNames from 'classnames';

type Props = {
  address?: string;
  fulladdr?: string;
  className?: string;
  containerclassname?: string;
  mapclassname?: string;
};

export const GoogleMap = (props: Props) => {
  const ctx = useClientContext();

  let address = props.address ? props.address : props.fulladdr;

  if (!address) {
    address = ctx.siteTokens.address ?? '';
  }

  const url = `https://www.google.com/maps?q=${encodeURIComponent(
    address
  )}&output=embed`;

  return (
    <div
      className={classNames(
        `${props.className} ${props.containerclassname || ''} ui-h-full`
      )}
    >
      <iframe
        src={url}
        title={address}
        className="ui-h-auto ui-max-h-full ui-w-full ui-aspect-video ui-border-0"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        frameBorder="0"
        allowFullScreen
      />
    </div>
  );
};

export default GoogleMap;
